/**
 * @deprecated 布局协议已迁至 `@dbl/core/dashboard`；本文件仅保留 DashboardLayout 组件私有 UI 常量。
 */
export {
  FILTER_WRAP_I,
  AI_ANALYSIS_TYPE,
  EMPTY_USER_FILTER,
  layoutItemOption,
  gridLayoutConfig,
  filterOperateConfig,
} from '@dbl/core/dashboard';

/** TopFilters 内 DatalabGrid 双列布局下单行估算高度（与栅格辅助线 56px 对齐） */
export const TOP_FILTER_ROW_HEIGHT_PX = 56;

/** 通用筛选区与用户筛选区之间的栅格间距 */
export const TOP_FILTER_SECTION_GAP_PX = 20;

/**
 * 贴顶/首行图表：tooltip 定位时 `top` 允许的最小值（px）。
 * 负值表示浮窗可向上超出图表视区，用于大浮窗可读性；上限与 iframe 裁剪对齐。
 */
export const TOOLTIP_MIN_TOP_PX = -140;

export const FILTER_OPERATE_CONTAINER = 'filter-operate-container';
